import React from 'react';
import classNames from 'classnames';
import './ValidationError.styles.scss';

type ValidationErrorProps = {
  className?: string;
  showError: boolean;
  error?: string | React.ReactNode;
};

const ValidationError: React.FC<ValidationErrorProps> = (props) => {
  const { className, showError, error } = props;

  const classes = classNames('anys-validation-error', className);

  return showError ? <div className={classes}>{error}</div> : null;
};

export default ValidationError;
